import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import {
  et3ParseInteger,
  getOnlyDigitsFromString,
  isDefinedString,
  isPositiveNumber
} from "et3-type-guards";
import { runInAction } from "mobx";
import i18n from "../../../../../../constants/i18n";
import { MAXIMUM_PHONE_NUMBER_DIGITS_ALLOWED } from "../../../../../../constants/input-entries-constants";
import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";
import getCorePersonalStore from "../../../../../../stores/core/core-personal-store";
import getKhattabatStore from "../../../../../../stores/khattabat-stores";
import getKhattabat101CGeneralStore from "../../../../../../stores/khattabat-stores/101c-stores/101c-general-store";
import getKhattabat101CStore from "../../../../../../stores/khattabat-stores/101c-stores";
import getKhattabat102GeneralStore from "../../../../../../stores/khattabat-stores/102-stores/general-102-store";
import getKhattabatSharedMessagingStore from "../../../../../../stores/khattabat-stores/messaging-stores/conversation-messaging-store";
import { E_KHATTABAT_CONVERSATION_TYPE } from "../../../../../../Types";

const KhattabatCreateOneOTwo = withLiteObserverAndTheme<{
  conversationID: string;
  userID: number;
}>((props) => {
  const { conversationID, userID } = props;
  const isKhattabaAiAdmin = getCorePersonalStore().isKhattabaAiAdmin.get();
  const isPaidConversation =
    getKhattabat101CGeneralStore().conversationsClientType.get() === "PAID";
  const conversationType =
    getKhattabatSharedMessagingStore(conversationID).conversationType.get();
  const { userUUID, isVIPKhatabat, insertUserIdField } =
    getKhattabat101CStore(userID);
  const { alkhattabaUUID } = getKhattabatStore();

  const shouldShow =
    !isKhattabaAiAdmin &&
    isPaidConversation &&
    conversationType === E_KHATTABAT_CONVERSATION_TYPE.ONE_O_ONE_C;
  const matchUserId = insertUserIdField.get();
  const isDisabledButton =
    !isDefinedString(alkhattabaUUID.get()) ||
    !isDefinedString(userUUID.get()) ||
    !isPositiveNumber(matchUserId) ||
    !isVIPKhatabat.get();

  return !shouldShow ? null : (
    <Stack direction="row" spacing={1} alignItems="center">
      <TextField
        size="small"
        value={isPositiveNumber(matchUserId) ? `${matchUserId}` : ""}
        placeholder={i18n.get("USER_ID")}
        onChange={({ target }) => {
          const parsedStringValue = getOnlyDigitsFromString(target.value);
          if (parsedStringValue.length < MAXIMUM_PHONE_NUMBER_DIGITS_ALLOWED) {
            const parsedIntegerValue = et3ParseInteger(parsedStringValue);
            runInAction(() => insertUserIdField.set(parsedIntegerValue));
          }
        }}
        slotProps={{
          htmlInput: {
            inputMode: "numeric",
            "aria-label": i18n.get("USER_ID")
          }
        }}
        sx={{ width: 160 }}
      />
      <Button
        variant="contained"
        disabled={isDisabledButton}
        onClick={() => getKhattabat102GeneralStore().createOneOTwo(userID)}
      >
        {i18n.get("CREATE_ONE_O_TWO")}
      </Button>
    </Stack>
  );
});

export default KhattabatCreateOneOTwo;
